import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Smartphone, Wifi, WifiOff, ArrowRight } from 'lucide-react';
import PageBreadcrumb from '../common/PageBreadcrumb';
import PageHeader from '../common/PageHeader';

const MobileAppAccess = () => {
  const navigate = useNavigate();

  const mobileFeatures = [
    {
      id: 'pwa',
      title: 'PWA Configuration',
      description: 'Configure Progressive Web App settings for mobile access.',
      icon: <Wifi size={24} />,
      path: '/system/mobile/pwa',
      color: 'var(--gold-primary)'
    },
    {
      id: 'devices',
      title: 'Device Registration',
      description: 'Register and manage mobile devices for secure access.',
      icon: <Smartphone size={24} />,
      path: '/system/mobile/devices',
      color: '#059669'
    },
    {
      id: 'offline',
      title: 'Offline Mode Settings',
      description: 'Configure offline capabilities and data synchronization.',
      icon: <WifiOff size={24} />,
      path: '/system/mobile/offline',
      color: '#8B5CF6'
    }
  ];

  const handleCardClick = (path) => {
    navigate(path);
  };

  return (
    <>
      <PageBreadcrumb />
      <PageHeader
        title="Mobile App Access"
        description="Configure mobile and PWA access for seamless on-the-go management of your contracts and assets"
      />
      <div className="page-container">
        {/* Features Grid */}
        <div
          className="grid-modern-3"
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            width: '100%'
          }}
        >
          {mobileFeatures.map((feature) => (
            <div
              key={feature.id}
              className="asset-landing-card"
              onClick={() => handleCardClick(feature.path)}
            >
              {/* Top Accent Line */}
              <div
                style={{
                  height: '4px',
                  background: `var(--primary-color)`,
                  width: '100%'
                }}
              />

              {/* Card Content */}
              <div style={{ padding: '24px' }}>
                {/* Icon and Title */}
                <div className="d-flex align-items-center mb-3">
                  <div
                    style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: 'var(--radius-lg)',
                      background: `${feature.color}20`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '16px'
                    }}
                  >
                    <div style={{ color: feature.color }} className="asset-card-icon">
                      {feature.icon}
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <h4 style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      color: 'var(--text-primary)',
                      margin: '0',
                      fontFamily: 'var(--font-family)'
                    }}>
                      {feature.title}
                    </h4>
                  </div>
                  <ArrowRight
                    size={20}
                    className="asset-card-arrow"
                  />
                </div>

                {/* Description */}
                <p style={{
                  fontSize: '13px',
                  color: 'var(--text-secondary)',
                  margin: '0',
                  lineHeight: '1.4',
                  fontFamily: 'var(--font-family)'
                }}>
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MobileAppAccess;
